/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Control_Parallel_DescInputs */

const en_mk_team_control_parallel_desc = /** @type {(inputs: Mk_Team_Control_Parallel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose parallelism, token/cost thresholds, and a deadline. Work already running may exceed the usage thresholds.`)
};

const id_mk_team_control_parallel_desc = /** @type {(inputs: Mk_Team_Control_Parallel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih paralelisme, ambang token/biaya, dan waktu kerja. Pekerjaan yang sudah berjalan bisa melampaui ambang pemakaian.`)
};

/**
* | output |
* | --- |
* | "Choose parallelism, token/cost thresholds, and a deadline. Work already running may exceed the usage thresholds." |
*
* @param {Mk_Team_Control_Parallel_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_control_parallel_desc = /** @type {((inputs?: Mk_Team_Control_Parallel_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Control_Parallel_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_control_parallel_desc(inputs)
	return en_mk_team_control_parallel_desc(inputs)
});